import { GoalType } from '@griply/types';
import {
  useCreateSubGoalAllowed,
  useCreateUnlimitedGoalsAllowed,
} from 'features/goals';
import { useCallback } from 'react';
import {
  CreateGoalOptions,
  useOpenCreateGoalDialog,
  useOpenCreateProjectDialog,
} from 'shared/contexts/goal-form';
import { useOpenPremiumDialog } from 'shared/contexts/premium-dialog';

// The section-header "+": the Projects list creates projects, every other list creates goals.
export const useOpenCreateInList = (isProjectList?: boolean) => {
  const openCreateGoal = useOpenCreateGoalDialog();
  const openCreateProject = useOpenCreateProjectDialog();
  const openPremiumDialog = useOpenPremiumDialog();
  const { allowed: createGoalAllowed } = useCreateUnlimitedGoalsAllowed();
  const { allowed: createSubGoalAllowed } = useCreateSubGoalAllowed();
  const { allowed: createProjectAllowed } = useCreateUnlimitedGoalsAllowed(
    GoalType.Project,
  );

  return useCallback(
    (options: CreateGoalOptions) => {
      const isSubGoal = !!options.parentIds?.length;
      const createGoalInListAllowed = isSubGoal
        ? createSubGoalAllowed
        : createGoalAllowed;
      const allowed = isProjectList
        ? createProjectAllowed
        : createGoalInListAllowed;
      if (!allowed) {
        openPremiumDialog();
        return;
      }
      isProjectList ? openCreateProject(options) : openCreateGoal(options);
    },
    [
      isProjectList,
      createGoalAllowed,
      createSubGoalAllowed,
      createProjectAllowed,
      openCreateGoal,
      openCreateProject,
      openPremiumDialog,
    ],
  );
};
